import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges } from '@angular/core';

import { AssetCategoryType } from '../../domain/public-api';

@Component({
  selector: 'td-wb-asset-category-icon',
  template: '<span class="td-wb-lti-asset-category-icon" [ngClass]="assetCategoryClass"></span>',
  styleUrls: ['asset-category-icon.component.scss'],
  imports: [
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetCategoryIconComponent implements OnChanges {

  private static readonly ASSET_CATEGORY_COLOR_CLASS: Map<AssetCategoryType, string> = new Map<AssetCategoryType, string>([
    [AssetCategoryType.CANADIAN_EQUITIES, 'td-wb-lti-asset-category-canadian_equities'],
    [AssetCategoryType.US_EQUITIES, 'td-wb-lti-asset-category-us_equities'],
    [AssetCategoryType.INTERNATIONAL_EQUITIES, 'td-wb-lti-asset-category-international_equities'],
    [AssetCategoryType.CANADIAN_FIXED_INCOME, 'td-wb-lti-asset-category-canadian_fixed_income'],
    [AssetCategoryType.INTERNATIONAL_FIXED_INCOME, 'td-wb-lti-asset-category-international_fixed_income'],
    [AssetCategoryType.CASH, 'td-wb-lti-asset-category-cash'],
    [AssetCategoryType.OTHER, 'td-wb-lti-asset-category-other'],
    [AssetCategoryType.UNCLASSIFIED, 'td-wb-lti-asset-category-unclassified']
  ]);

  @Input() assetCategoryType: AssetCategoryType;

  assetCategoryClass: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.assetCategoryType !== undefined && changes.assetCategoryType.currentValue !== undefined) {
      this.assetCategoryClass = this.getAssetCategoryStyle(changes.assetCategoryType.currentValue);
    }
  }

  private getAssetCategoryStyle(assetCategoryType: AssetCategoryType): string {
    return AssetCategoryIconComponent.ASSET_CATEGORY_COLOR_CLASS.get(assetCategoryType);
  }

}
